import { render, staticRenderFns } from "./Biodata.vue?vue&type=template&id=67280451&scoped=true&"
import script from "./Biodata.vue?vue&type=script&lang=js&"
export * from "./Biodata.vue?vue&type=script&lang=js&"
import style0 from "./Biodata.vue?vue&type=style&index=0&id=67280451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67280451",
  null
  
)

export default component.exports